import React, { useEffect, useState } from "react";
import axios from "axios";

import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import campraImg from "../../Img/CamptraLogoBg.png";
import { API_BASE_URL } from "../../utils/config";

// import campraImg from "../../Img/newCampralogo.png"

import Footer from "../Footer/Footer";
import { toast } from "react-toastify";
const Login = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [campraImg, setCampraImg] = useState(localStorage.getItem("logoImg"));
  const [adminIds, setAdminIds] = useState([]);
  const [tenantAdmins, setTenantAdmins] = useState([]);
  const [allusers, setAllUsers] = useState([]);
  const [allusersAndTenatAdmin, setAllUsersAndTenatAdmin] = useState([]);
  const navigate = useNavigate();

  const isValidEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };

  const getAdminIds = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom-user-api/v1/users`)
      .then((res) => {
        let ids = [];
        for (let i = 0; i < res.data.length; i++) {
          if (
            res.data[i].user_roles == "administrator" &&
            res.data[i].user_status == "active"
          ) {
            ids.push(res.data[i].ID);
          }
        }
        console.log("adminids=", ids);
        setAdminIds(ids);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sendingEmail = (val) => {
    let data = {
      email: email,
      ids: adminIds,
      registered: val,
    };

    axios
      .post(`${API_BASE_URL}/wp-json/custom/v1/send-email`, data, {
        headers: {
          // 'Authorization': `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/image`, {
        // headers: {
        //   'Authorization': `Bearer ${bearerToken}`,
        //   'Content-Type': 'application/json',
        // }
      })
      .then((res) => {
        console.log("line33=", res);
        localStorage.setItem("logoImg", res.data);
        setCampraImg(res.data);
      });

    getAdminIds();
  }, [campraImg]);
  // const campraImg = localStorage.getItem("logoImg")

  const handleGetOTP = (e) => {
    e.preventDefault();

    console.log("email=", email);
    if (!email) {
      setError("Email is required");
    } else if (!isValidEmail(email)) {
      setError("Invalid email format");
    } else {
      // Redirect to the OTP page if the email is correct
      // axios.post
      // POST Request with Bearer Token

      let emailbody = {
        user_email: email,
      };
      console.log(emailbody);
      console.log("lin52=", allusersAndTenatAdmin);
      if (allusersAndTenatAdmin.includes(email)) {
        if (allusers.includes(email)) {
          axios
            .post(`${API_BASE_URL}/wp-json/wp/v2/sendotp`, emailbody, {
              headers: {
                // 'Authorization': `Bearer ${bearerToken}`,
                "Content-Type": "application/json",
                Accept: "*/*",
              },
            })

            // Content - Type: application / json

            .then((response) => {
              // Handle the POST response here
              console.log("POST Response:", response.data);
              toast.success(response.data.message);
              localStorage.setItem("userEmail", email);
              navigate("/otp");
            })
            .catch((error) => {
              // Handle POST request errors here
              // console.error('POST Error:', error);
              toast.error(error.response.data.message);
              if (error.response.data.message == "User not registered. ") {
                sendingEmail("not-registered");
              } else {
                sendingEmail();
              }
            });
        } else {
          if (tenantAdmins.includes(email)) {
            axios
              .post(`${API_BASE_URL}/wp-json/wp/v2/sendotp`, emailbody, {
                headers: {
                  // 'Authorization': `Bearer ${bearerToken}`,
                  "Content-Type": "application/json",
                  Accept: "*/*",
                },
              })

              // Content - Type: application / json

              .then((response) => {
                // Handle the POST response here
                console.log("POST Response:", response.data);
                toast.success(response.data.message);
                localStorage.setItem("userEmail", email);
                navigate("/otp");
              })
              .catch((error) => {
                // Handle POST request errors here
                // console.error('POST Error:', error);
                toast.error(error.response.data.message);
                if (error.response.data.message == "User not registered. ") {
                  sendingEmail("not-registered");
                } else {
                  sendingEmail();
                }
              });
          } else {
            toast.error(
              "Login failed: This User is a tenant admin but is not assigned to a tenant."
            );
          }
        }
      } else {
        toast.error("User not registered.");
      }
    }
  };
  const getTenentAdmins = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom-user-api/v1/users`)
      .then((res) => {
        const tenantEmails = [];
        const FilterallusersAndTenatAdmin = [];
        const allUsersEmail = [];
        const filterTentAdmin = res.data.filter((res) => {
          FilterallusersAndTenatAdmin.push(res.user_email);
          if (res.user_roles == "editor") {
            tenantEmails.push(res.user_email);
            // return res.user_email;
          } else {
            allUsersEmail.push(res.user_email);
          }
        });
        console.log(filterTentAdmin);
        // setTenantAdmins(tenantEmails);
        setAllUsers(allUsersEmail);
        setAllUsersAndTenatAdmin(FilterallusersAndTenatAdmin);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getTenentAdminsEamil = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`)
      .then((res) => {
        const tenantEmails = [];

        const filterTentAdmin = res.data.map((res) => {
          console.log(res.tenent_user_email);
          tenantEmails.push(res.tenent_user_email);
        });
        // console.log("tenantEmailsefe", tenantEmails);
        setTenantAdmins(tenantEmails);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getTenentAdmins();
    getTenentAdminsEamil();
    let token = localStorage.getItem("jwt_token");
    if (token) {
      navigate("/all-articles");
    }
  }, []);

  return (
    <div className="">
      {/* <div className=" login-left-column  p-0 ">
        
        <img src={campraImg} alt=""
       
          className='login-left-logo-new m-0'
        />
        <h1 className='text-white'>Knowledge Repository</h1>



       
      </div> */}
      <div className="row g-0">
        <div className="col-lg-3 col-md-3 col-sm-1"></div>
        <div className="col-lg-6 col-md-8 col-sm-10  ">
          {/* <!-- Content for the right column goes here --> */}
          <div className="d-flex flex-column align-items-center mt-5 pt-5">
            <div className="text-center  me-4 px-5 mb-3">
              <img className="w-50" src={campraImg} alt="" />
            </div>
            <h3 className="fw-bold text-center">
              Welcome To Knowledge Repository
            </h3>
            <h3
              className="fw-bold text-center mt-2"
              style={{ color: "#092360" }}
            >
              User Login
            </h3>
            {/* <div className='row g-0 '> */}
            {/* <div className="col-2"></div> */}
            {/* <div className="col-12"> */}
            <form className="w-50" onSubmit={handleGetOTP}>
              {/* <label style={{ fontSize: '1.2rem' }} for="exampleInputEmail1"><strong>Email ID <span className='text-danger'>*</span></strong></label> */}
              <input
                type="email"
                required
                onInvalid={() => {
                  setError("Invalid email format");
                  setTimeout(() => {
                    setError(undefined);
                  }, 2000);
                }}
                placeholder="Email id"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control my-4 p-2"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
              />
              {error && <p className="error">{error}</p>}
              <div className="text-center">
                <button
                  style={{ background: "#092360", color: "white" }}
                  type="submit"
                  className="btn  rounded-pill  m-0 p-2 px-4 fw-bold"
                >
                  Login
                </button>
              </div>
              {/* <Link className="btn btn-primary get-otp" to="otp" >Get OTP</Link> */}
            </form>
            {/* </div> */}
            {/* <div className="col-2"></div> */}
            {/* </div> */}
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-1"></div>
      </div>
    </div>
  );
};

export default Login;
